import fr from 'facet-rest';

const statusColors = {
  todo: 'primaryBlue',
  'in-progress': 'accentBlue',
  pending: 'accentBlue2',
  review: 'accentGreen7',
  completed: 'accentGreen2',
  'not-applicable': 'inherit',
};

const TodayDashboardTasksOverride = fr.metaOverride()
  .nameOverride('status', {
    _customProps: {
      color: ({ resource }) => {
        let c;
        if (resource.attr('status') in statusColors) {
          c = statusColors[resource.attr('status')];
        }
        return c;
      },
      variant: 'filled',
      SelectProps: {
        disableUnderline: true,
        autoWidth: false,
      },
    },
    readonly: false,
    _hideLabel: true,
  });

export default TodayDashboardTasksOverride;
